import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from "@angular/core";

@Component({
    selector: "common-form-slider",
    template: `
        <div *ngIf="label">{{ label }}:
            <span class="pull-right">
                <input type="number" #inputRef [value]="inputValue" [min]="min" [max]="max" [step]="step"
                       [required]="required" (keyup)="keyUp($event.target.value)"
                       (change)="inputChange($event.target.value)">
            </span>
        </div>

        <div>
            <mat-slider [min]="min" [max]="max" [step]="step" discrete showTickMarks>
                <input matSliderThumb [value]="sliderValue" (valueChange)="sliderChange($event)">
            </mat-slider>
        </div>
    `,
    styleUrls: [
        "slider.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CommonFormSliderComponent implements OnInit, OnDestroy {

    /**
     * Component destroy event emitter
     * @type {EventEmitter<boolean>}
     */
    private destroy$: EventEmitter<boolean> = new EventEmitter<boolean>();

    private timer: any;

    @Input()
    public label: string = null;

    @Input()
    public min: number = 0;

    @Input()
    public max: number = 100;

    @Input()
    public step: number = 1;

    @Input()
    public required: boolean = false;

    @Input()
    public value: number = null;

    public sliderValue: number = 1;
    public inputValue: number = 1;

    @ViewChild("inputRef", {static: false})
    public inputRef: ElementRef;


    @Output()
    public valueChange: EventEmitter<number> = new EventEmitter<number>();

    public constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    public fixValue(value: number): number {
        if (value < this.step) {
            return this.step;
        } else if (value > this.max) {
            value = this.max;
        } else if (value % this.step !== 0) {
            return Math.floor(value / this.step) * this.step + this.step;
        }
        return value;
    }

    public keyUp(value): void {
        this.valueChange.emit(null);
        this.changeDetectorRef.markForCheck();

        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.timer = setTimeout(() => {
            this.inputChange(value);
        }, 2000);
    }

    public inputChange(value: number): void {
        value = this.fixValue(value);
        this.inputRef.nativeElement.value = value;
        this.sliderValue = value;
        this.valueChange.emit(value);
        this.changeDetectorRef.markForCheck();
    }


    public sliderChange(value): void {
        this.inputValue = value;
        this.valueChange.emit(value);
        this.changeDetectorRef.markForCheck();
    }

    public ngOnInit(): void {
        if (this.value) {
            this.sliderValue = this.fixValue(this.value);
            this.inputValue = this.fixValue(this.value);
            this.changeDetectorRef.markForCheck();
        }
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();

        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
}
